import { ReactElement } from 'react';
import { FormNodeBase } from '../../../../../shared/kiosk';
import { StringTranslator } from '../../../../translations';

export interface UpdateFormProps<T extends FormNodeBase> {
  node: T;
  update: (node: T) => void;
  ts: StringTranslator;
}

/**
 * @deprecated This is a temporary hack, getUpdateForm should be a getter for a component type or a component type directly!
 */
export type UpdateFormPropsNoTrans<T extends FormNodeBase> = Omit<UpdateFormProps<T>, 'ts'>;
export abstract class AbstractElementEditor<T extends FormNodeBase> {
  public getDefaultValues(): Partial<Omit<T, 'id' | 'type'>> {
    return {};
  }

  public getUpdateForm?(_props: UpdateFormProps<T>): ReactElement | null;
  public abstract getDescription(input?: T): ReactElement | string;
  public abstract getName(): string;
  public abstract getIcon(): string;
}
